import { serverError } from '@/utilities/serverError';
import { GoogleGenAI } from '@google/genai';

export enum AITextModel {
  gemini3ProPreview = 'gemini-3.1-pro-preview',
  geminiFlashLiteLatest = 'gemini-flash-lite-latest',
  gemini3_1FlashLitePreview = 'gemini-3.1-flash-lite-preview',
}

export enum AIThinkingLevel {
  deep = 'deep',
  fast = 'fast',
}

export type GeminiAITextSetting = {
  model: string;
};

let fileSearchStoreNameCache: string | null = null;

const defaultStoreDisplayName = 'bigscreen-assist-documents';

export async function getFileSearchStoreName(
  ai: GoogleGenAI,
): Promise<string | ReturnType<typeof serverError>> {
  if (fileSearchStoreNameCache) {
    return fileSearchStoreNameCache;
  }

  const stores = await ai.fileSearchStores.list();
  for await (const store of stores) {
    if (store.displayName === defaultStoreDisplayName) {
      fileSearchStoreNameCache = store.name || null;
      if (fileSearchStoreNameCache) {
        return fileSearchStoreNameCache;
      }
    }
  }

  const createdStore = await ai.fileSearchStores.create({
    config: { displayName: defaultStoreDisplayName },
  });
  fileSearchStoreNameCache = createdStore.name || null;
  if (!fileSearchStoreNameCache) {
    return serverError('Failed to create file search store');
  }
  return fileSearchStoreNameCache;
}

export async function createAiClient() {
  if (!process.env.GOOGLE_API_KEY) {
    return serverError('Missing Google API key', 500);
  }
  return new GoogleGenAI({ apiKey: process.env.GOOGLE_API_KEY });
}
